export const defaultGroupRowHeight = {
  collapsed: 40,
  expanded: 64,
  secondaryRow: 40
};
